/* eslint-disable react-hooks/exhaustive-deps */
// @vendors
import React, {createContext, useEffect, useMemo, useState} from 'react'
import {Container, Grid} from '@mui/material';
import { useDispatch } from 'react-redux';

// @components
import ListOrganizations from './ListOrganizations';
import Pageheader from '../../components/PageHeader';

// @context
import { useUI } from '../../app/context/ui';

// @helpers
import { getOrganizations } from '../../helpers/FunctionsUtils';

// @assets
import { GeneralStyles } from '../../assets/css/general-style';

// @redux
import { types } from '../../redux/types';
import store from '../../redux/store';

const OrganizationScreen = () => {
  const { blockUI, snackbarUI } = useUI();
  const generalStyle = useMemo(() => GeneralStyles(), []);
  const dispatch = useDispatch()
  const state = store.getState();
  const [rowsState, setRowsState] = useState([]);

  const getListOrganization = async (hasDispatch=false) => {
    const params = {snackbarUI, blockUI, loading:true, status: false}
    const response = await getOrganizations(params);
    setRowsState(response?.data?.data);
    const activeOrganization = response?.data?.data?.filter((x) => x?.status === 'enable');
    if(hasDispatch){
      const organizationSelected = activeOrganization?.find((item) => item?.id === state?.organizationReducer?.organizationSelected?.id);
      dispatch({
        type: types.ORGANIZATIONS_LIST,
        data: activeOrganization,
        organizationSelected: organizationSelected ?? activeOrganization[0]
      })
    }
  }

  useEffect(() => {
    getListOrganization();
  }, [])

  return (
    <Container
      component="section"
      maxWidth="xl"
      sx={generalStyle.dashCtn}
    >
      <Container
        component="section"
        maxWidth="xl"
        sx={generalStyle.containerTitle}
      >
        <Pageheader
          title={'Organizations'}
          subtitle={'Welcome to organizations dashboard'}
        />
      </Container>
      <Grid>
          <Organization.Provider value={{rowsState, getListOrganization}}>
            <ListOrganizations/>
          </Organization.Provider>
      </Grid>
    </Container>
  )
}

export const Organization = createContext({});
export default OrganizationScreen